import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopUI').create(({ theme }) => ({
  root: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },

  content: {
    position: 'relative',
    display: 'flex',
    minWidth: '100px',
    justifyContent: 'center',
    alignItems: 'center',
    aspectRatio: '1/1',
    background: 'rgba(240, 245, 250, 0.05)',
    borderRadius: theme.sizes.radiuses.l,
    border: '1px solid',
    borderColor: theme.colors.borders.default,

    '&[data-isbest="true"]': {
      borderColor: theme.colors.borders.legendary,
    },
  },

  itemValue: {
    color: 'white',
    position: 'absolute',
    bottom: '18px',
    right: '12px',
    fontFamily: 'Space Grotesk',
    fontWeight: '540',
    fontSize: '22px',
    lineHeight: '100%',
    letterSpacing: '0%',
    textAlign: 'right',
    verticalAlign: 'middle',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },

  itemPriceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',

    img: {
      width: '16px',
    },

    span: {
      color: 'white',
      fontFamily: 'Space Grotesk',
    },
  },

  specialMark: {
    position: 'absolute',
    left: '4px',
    top: '4px',
    display: 'flex',
    gap: '2px',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    borderRadius: '24px',

    span: {
      color: 'white',
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: 450,
    },
  },
}))
